import React, { createContext, useContext, useState } from 'react';
const FeatureFlagContext = createContext(null);
export const FeatureFlagProvider = ({ children }) => {
    const [flags, setFlags] = useState({
        disableTrading: false
    });
    return (React.createElement(FeatureFlagContext.Provider, { value: flags }, children));
};
export const useFeatureFlag = (flagName) => {
    const flags = useContext(FeatureFlagContext);
    return flags && flags[flagName] || false;
};
